<template>
  <div class="col-5 text-center">
    <div class="row tight">
      <div class="col-4">
        <under-input v-model.lazy.number="hitPoints.current" maxlength="3">
          <span class="d-none d-md-inline">Current</span>
          <span class="d-inline d-md-none">Cur</span>
        </under-input>
      </div>
      <div class="col-4">
        <under-input v-model.lazy.number="hitPoints.maximum" maxlength="3">Max</under-input>
      </div>
      <div class="col-4">
        <under-input v-model.lazy.number="hitPoints.temp" maxlength="3">Temp</under-input>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import UnderInput from "../shared/_UnderInput.vue";

export default {
  name: "big-boxes-hit-points",
  components: {
    UnderInput
  },
  computed: mapState({
    hitPoints: state => state.characters.current.defense.hitPoints
  })
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/_global";
</style>
